import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const EMPRUNT_URL = `${backendUrl}/api/emprunt/`;

class EmpruntService {
	async getAllEmprunts() {
		try {
			const response = await axios.get(EMPRUNT_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getEmprunt(id) {
		return axios.get(`${EMPRUNT_URL}${id}/`);
	}

	createEmprunt(data) {
		return axios.post(EMPRUNT_URL, data);
	}

	updateEmprunt(id, data) {
		return axios.put(`${EMPRUNT_URL}${id}/`, data);
	}

	deleteEmprunt(id) {
		return axios.delete(`${EMPRUNT_URL}${id}/`);
	}

	getEmpruntNames(personelIds) {
		return axios.get(`${EMPRUNT_URL}?personelIds=${personelIds}`);
	}

	getEmpruntOptions() {
		return this.getAllEmprunts().then((emprunts) => {
			const options = emprunts.map((emprunt) => ({
				value: emprunt.id,
				label: emprunt.eleve.toUpperCase()
			}));
			// options.unshift({value: null, label: 'Selectionner la salle de emprunt'});
			return options;
		});
	}
}

export default new EmpruntService();
